export const IHrefTpye = {
  tel: 'tel',
  mail: 'mail'
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSResolvePhoneOrMail/util.ts